import store from '@/store';

export const rolesRedirectPages = {
    intern: '/receive-orders',
    operator: '/receive-orders',
    manager: '/users/drivers',
    boss: '/users/drivers',
    admin: '/users/drivers',
    accountant: '/reports',
    'corporate-admin': '/users/operators',
    'corporate-user': '/receive-orders',
    leader: '/reports',
    'admin-delivery': '/users/operators',
    'admin-establishment': '/users/operators',
    'manager-establishment': '/receive-orders',
    'manager-establishment-ext': '/receive-orders'
};

export async function isAuth(to, from, next) {
    await store.dispatch('auth/getUser');

    const { permission, requireExtendedCapabilities } = to.meta;
    const { roleName, operator } = store.getters;

    const defaultRedirectPage = rolesRedirectPages[roleName];
    const hasExtendedCapabilities = operator && operator.extendedCapabilities;

    if (!store.getters.loggedIn) {
        return next('/login');
    }

    if (!permission.includes(roleName)) {
        return next(defaultRedirectPage);
    }

    if (['boss'].includes(roleName) && requireExtendedCapabilities && !hasExtendedCapabilities) {
        return next(defaultRedirectPage);
    }

    next();
}

export async function isNotAuth(to, from, next) {
    if (store.getters.loggedIn) {
        return next(rolesRedirectPages[store.getters.roleName]);
    }

    next();
}

export async function getUser(to, from, next) {
    await store.dispatch('auth/getUser');

    next();
}
